import Layout from '../../internal/Layout.vue'
import DepartmentPage from './deparment/department.vue'
import qrCodes from './deparment/qrCodes.vue'
import importDepartment from './deparment/import.vue'

const DepartmentRoutes = {
  component: Layout,
  children: [
    {
      name: 'department',
      path: '/',
      component: DepartmentPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
    {
      name: 'sectorExportQrcode',
      path: '/exportQrcode',
      component: qrCodes,
      props: true,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'importDepartment',
      path: '/importDepartment',
      component: importDepartment,
      props: true,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default DepartmentRoutes
